// UI Feedback utilities - toast notifications and shake animations

const TOAST_DURATION_MS = 1500;
const SHAKE_DURATION_MS = 350;

/**
 * Create a toast manager that handles showing/hiding toast messages
 * 
 * @param {Object} handlers - Handler functions
 * @param {Function} handlers.setMessage - Function to set toast message (null to hide)
 * @param {Function} handlers.getTimer - Function to get current timer ref
 * @param {Function} handlers.setTimer - Function to set timer ref
 * @returns {Function} Show toast function
 */
export function createToastManager({ setMessage, getTimer, setTimer }) {
  return function showToast(message) {
    const currentTimer = getTimer();
    if (currentTimer) {
      clearTimeout(currentTimer);
      setTimer(null);
    }
    setMessage(message);
    const newTimer = setTimeout(() => {
      setTimer(null);
      setMessage(null);
    }, TOAST_DURATION_MS);
    setTimer(newTimer);
  };
}

/**
 * Trigger a shake animation on an element
 * 
 * @param {HTMLElement|null} element - Element to shake (falls back to board if null)
 * @param {string} shakeClass - CSS class name for shake animation
 */
export function triggerShake(element, shakeClass = 'gc-shake') {
  const el = element || document.getElementById('grotto-board');
  if (!el) return;
  el.classList.remove(shakeClass);
  // Force reflow to restart animation
  void el.offsetWidth;
  el.classList.add(shakeClass);
  window.setTimeout(() => {
    el.classList.remove(shakeClass);
  }, SHAKE_DURATION_MS);
}

/**
 * Find the element to shake based on origin and benchId
 * 
 * @param {string|null} origin - Origin of the drag ('bench' or other)
 * @param {number|null} benchId - Bench item ID
 * @returns {HTMLElement|null} Element to shake
 */
export function findShakeTarget(origin, benchId) {
  if (origin === 'bench' && benchId != null) {
    const benchEl = document.querySelector(`[data-bench-id="${benchId}"]`);
    if (benchEl) return benchEl;
  }
  return document.getElementById('grotto-board');
}

/**
 * Shake an element based on drag origin context
 * 
 * @param {string|null} origin - Origin of the drag ('bench' or other)
 * @param {number|null} benchId - Bench item ID
 * @param {string|null} targetSquare - Target square (unused but kept for API compatibility)
 */
export function shakeInvalidDrop(origin, benchId, targetSquare) {
  const el = findShakeTarget(origin, benchId);
  triggerShake(el);
}






